import { SUBJECT_PHOTO_CAROUSEL_FEATURES } from '../SubjectPhotoCarousel/subjectPhotoCarousel.constants';

export const SUBJECT_PHOTO_CARD_FEATURES = SUBJECT_PHOTO_CAROUSEL_FEATURES;
